import React, {useContext} from 'react';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {MULTI_UNIT_RESULT_COUNT} from '../utils/edap';
import MultiUnitItem from '../MultiUnitItem/MultiUnitItem';

import './MultiUnitListing.less';

const MultiUnitListing = ({
    context,
    isDatelessSearch,
    isMetric,
    multiUnitList,
    propertyId,
    clientLogger,
    messages
}) => {
    const trackingContext = useContext(TrackingContext);

    const checkForNullFields = (list, field) => {
        return list.hasOwnProperty(field) && list[field] === null;
    };

    const areListingsAvailable =
        multiUnitList &&
        multiUnitList.multiUnitSearch &&
        multiUnitList.multiUnitSearch.listings &&
        multiUnitList.multiUnitSearch.listings.length > 0;

    if (areListingsAvailable) {
        trackingContext.trigger(MULTI_UNIT_RESULT_COUNT, {
            propertyId,
            resultCount: multiUnitList.multiUnitSearch.listings.length
        });

        multiUnitList.multiUnitSearch.listings.map((list) => {
            Object.keys(list).forEach((property) => {
                if (checkForNullFields(list, property)) {
                    clientLogger.captureMessage(
                        `[MultiUnitSearchQuery warning]: Received null value for field - ${property} and Listing Id -  ${
                            list.listingId
                        }`
                    );
                }
            });
            if (checkForNullFields(list, 'priceSummary')) {
                clientLogger.captureException(
                    `[MultiUnitSearchQuery price error]: Received null value for price fields for Listing Id - ${
                        list.listingId
                    }`
                );
            }
        });
    }

    return (
        (areListingsAvailable &&
            multiUnitList.multiUnitSearch.listings.map((list) => (
                <MultiUnitItem
                    listing={list}
                    context={context}
                    isDatelessSearch={isDatelessSearch}
                    isMetric={isMetric}
                    key={list.listingId}
                    messages={messages}
                />
            ))) || <div className="MultiUnit__ErrorMessage">{messages.tempOopsMessage}</div>
    );
};

export default MultiUnitListing;
